import type { ReactNode } from "react";
import React, { createContext, useState, useContext } from "react";

interface AppSettings {
  themeMode: "auto" | "light" | "dark";
}

interface AppContextType {
  settings: AppSettings;
  onChange: (key: string, value: any) => void;
}

export const AppContext = createContext<AppContextType | undefined>(undefined);

interface AppProviderProps {
  children: ReactNode;
}

export const AppProvider: React.FC<AppProviderProps> = ({ children }) => {
  const [settings, setSettings] = useState<AppSettings>({
    themeMode: "auto",
  });

  const onChange = (key: string, value: any) => {
    console.log("key", key, "value", value);
    setSettings((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <AppContext.Provider
      value={{
        settings,
        onChange,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

// Custom hook for using the context
export const useAppSettings = () => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error("useAppSettings must be used within an AppProvider");
  }
  return context;
};
